<script lang="ts" setup>
import { computed } from 'vue'

import { formatNumber } from '../utils'

const props = withDefaults(
  defineProps<{
    score: number,
    total?: number,
    size?: 'sm' | 'md' | null,
    minimumFractionDigits?: number,
    maximumFractionDigits?: number
  }>(),
  {
    total: 0,
    size: 'sm',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }
)

const formattedScore = computed(() => {
  return formatNumber(props.score, props.minimumFractionDigits, props.maximumFractionDigits)
})

const scoreClass = computed(() => {
  return props.size === 'sm' ? 'text-heading-sm' : 'text-heading-md'
})

const totalClass = computed(() => {
  return props.size === 'sm' ? 'text-heading-2xs' : 'text-heading-xs'
})
</script>

<template>
  <div class="font-heading text-aside-foreground">
    <span :class="scoreClass">
      {{ formattedScore }}
    </span>
    <span v-if="total && total > 0"
          :class="totalClass">
      /{{ total }}
    </span>
  </div>
</template>
